import { STOCK_IMAGE_PATH_SEGMENT } from '~/constants/vdp/whyBuyMedia';
import optimizeImage from '~/utilities/optimizeImage';
import type { SelectedWhyBuyMedia } from './selectWhyBuyMedia';

type WhyBuyMediaProps = {
  imageUrl?: string;
  isStockImage: boolean;
  videoUrl?: string;
};

type Options = {
  height: number;
};

export default function getWhyBuyMediaProps(
  media: SelectedWhyBuyMedia | undefined,
  { height }: Options
): WhyBuyMediaProps {
  if (!media) {
    return { isStockImage: false };
  }

  const isStockImage = media.url
    .split('?')[0]
    .includes(STOCK_IMAGE_PATH_SEGMENT);

  if (media.mimeType.startsWith('video/')) {
    return { isStockImage, videoUrl: media.url };
  }

  const imageUrl = optimizeImage(media.url, {
    format: 'auto',
    height,
    optimize: 'high',
    quality: 90
  });

  return imageUrl ? { imageUrl, isStockImage } : { isStockImage: false };
}
